"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpCatalog = void 0;
const gs = require("@ivanlog/gs");
const App_1 = require("../App");
const tmpls_1 = require("./tmpls");
class CmpCatalog extends tmpls_1.CmpCatalogBase {
    constructor() {
        super();
        this._itemTops = [];
        this._categories = [];
        this._loadAsync();
    }
    set isMobile(value) {
        this._isMobile = value;
    }
    openMainCatalog() {
        this.ctrls.blockSubCategories.removeClass(CmpCatalog.ClassActive);
        this.ctrls.blockCategories.addClass(CmpCatalog.ClassActive);
        if (!this._subCategory)
            return false;
        this._subCategory = undefined;
        return true;
    }
    _loadAsync() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const categories = yield App_1.App.Inst.cache.getCategoriesAsync();
            if (!categories)
                return; //TODO сделать что-то если не загрузятся
            this._categories = categories;
            for (const cat of categories.filter(c => c.parentId == 0).sort((a, b) => a.sortIndex - b.sortIndex)) {
                const item = new tmpls_1.CmpCatalogItemTop();
                item.setData("cat", cat.id + "");
                if (cat.iconSVG)
                    (_a = item.ctrls.svgIcon.q('use').first) === null || _a === void 0 ? void 0 : _a.el.setAttribute('xlink:href', `files/categories_named.svg#${cat.iconSVG}`);
                item.ctrls.label.text = cat.name;
                item.ctrls.btn.onclick = () => this._openCategory(item, cat);
                item.ctrls.btn.removeClass(CmpCatalog.ClassActive);
                this.ctrls.ulCategories.append(item);
                this._itemTops.push(item);
            }
            if (this._itemTops.length > 0)
                this._itemTops[0].ctrls.btn.el.click();
        });
    }
    _createCatalogItem(category, subSubCats) {
        const subCategory = new tmpls_1.CmpCatalogItem();
        subCategory.ctrls.label.text = category.name;
        let hasItems = false;
        for (const subSubCat of subSubCats) {
            if (!subSubCat.productsCount)
                continue;
            const li = gs.w(gs.html.tag("li"));
            li.append(gs.html.a({ href: `/catalog/${subSubCat.id}` }, subSubCat.name));
            if (subSubCat.productsCount > 0)
                li.append(gs.html.span({}, subSubCat.productsCount + ""));
            subCategory.ctrls.list.append(li);
            hasItems = true;
        }
        if (!hasItems)
            return undefined;
        return subCategory;
    }
    _openCategory(item, category) {
        return __awaiter(this, void 0, void 0, function* () {
            this._subCategory = category;
            if (this._isMobile) {
                this.ctrls.blockSubCategories.addClass(CmpCatalog.ClassActive);
                this.ctrls.blockCategories.removeClass(CmpCatalog.ClassActive);
                this.ctrls.blockSubCategories.el.scrollTop = 0;
            }
            for (const itemTop of this._itemTops)
                itemTop.ctrls.btn.removeClass(CmpCatalog.ClassActive);
            item.ctrls.btn.addClass(CmpCatalog.ClassActive);
            this.ctrls.lCategoryTitle.text = category.name;
            this.ctrls.ulSubCategoryCol1.html = '';
            this.ctrls.ulSubCategoryCol2.html = '';
            this.ctrls.ulSubCategoryColMobile.html = '';
            let col1 = 0;
            let col2 = 0;
            for (const subCat of this._categories.filter(c => c.parentId == category.id).sort((a, b) => a.sortIndex - b.sortIndex)) {
                let subSubCats = this._categories.filter(c => c.parentId == subCat.id).sort((a, b) => a.sortIndex - b.sortIndex);
                let subCategoryItem = this._createCatalogItem(subCat, subSubCats);
                if (!subCategoryItem)
                    continue;
                this.ctrls.ulSubCategoryColMobile.append(subCategoryItem);
                subCategoryItem = this._createCatalogItem(subCat, subSubCats);
                if (col1 > col2) {
                    this.ctrls.ulSubCategoryCol2.append(subCategoryItem);
                    col2 += subSubCats.length + 1;
                }
                else {
                    this.ctrls.ulSubCategoryCol1.append(subCategoryItem);
                    col1 += subSubCats.length + 1;
                }
            }
            gs.StateGS.CatchLinks();
        });
    }
}
exports.CmpCatalog = CmpCatalog;
CmpCatalog.ClassActive = "active";
//# sourceMappingURL=CmpCatalog.js.map